import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import ReactGallery from 'react-photo-gallery';
import Lightbox from 'react-images';

export default class Gallery extends Component {
    constructor(props){
        super(props);
        this.state = {
            images : [],
            currentImage: 0,
            lightboxIsOpen: false
        };
    }

    componentDidMount(){
        let uri = window.location.pathname == '/' ? '/photos' : window.location.pathname + '/show';

        axios.get(uri || '/photos')
            .then(response => {
                const images = response.data;
                this.setState({
                    images
                })
            })
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {
        let photos = this.state.images.map(image => {
            return {
                album: image.albums ? image.albums : null,
                src : '/' + image.uri,
                width : image.width,
                height : image.height,
                id :  image.id,
                caption: image.caption || ''
            }
        });
        return (
            <div className="gallery">
                {this.state.images.length ?
                    <ReactGallery
                        photos={photos}
                        onClick={this.openLightbox.bind(this)}
                    />
                    :
                    <div className="no-images text-center">
                        <h5>
                            You currently have no images in your photos gallery
                        </h5>
                        <Link to="/upload"><strong>Upload some photos now</strong></Link>
                    </div>
                }

                <Lightbox
                    images={photos}
                    onClose={this.closeLightbox.bind(this)}
                    onClickPrev={this.gotoPrevious.bind(this)}
                    onClickNext={this.gotoNext.bind(this)}
                    currentImage={this.state.currentImage}
                    width={1080}
                    isOpen={this.state.lightboxIsOpen}/>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Gallery.js